const termsAndConditions = {
  title1: 'AVISO LEGAL',
  content1: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INFORMACIÓN CORPORATIVA</u>
        </li>
        <p class="body-1">
          En cumplimiento de la Directiva, 2000/31/CE, del Parlamento Europeo y del Consejo de 8 de
          junio de los Servicio de la Sociedad de la Información y Comercio Electronico, y de la Ley
          Española, 34/2002, de 11 de julio,
          <b>GLOSPEN, SL</b> le informa que es titular de los sitios web:
          <b>www.fbase.tv</b>, de acuerdo con la exigencia del artículo 10 de la mencionada Ley, GLOSPEN,
          SL, notifica los siguientes datos: el titular de esta página web es
          <b>GLOSPEN, SL</b> con NIF/CIF:
          <b>L713690W</b>. y domicilio social:
          <b>CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC- II 5º 2ª</b>,
          Código Postal:
          <b>AD700</b>. Localidad:
          <b>ESCALDES-ENGORDANY, PRINCIPAT D&#39;ANDORRA</b>. La
          dirección de correo electrónico de contacto con la empresa es:
          <b>
            <u>info@fbase.tv</u>
          </b>
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>USUARIO Y RÉGIMEN DE RESPONSABILIDADES</u>
        </li>
        <p class="body-1">
          La navegación por acceso o uso de la página web y todos los subdominios y directorios
          incluidos bajo la misma, así como los servicios o contenidos que a través de él se puedan
          obtener y todos los portales de dominio propio bajo titularidad de
          <b>GLOSPEN, SL</b>, otorga la
          Condición de
          <b>Usuario</b>, por la que se aceptan, al navegar por la página
          <b>GLOSPEN, SL</b>, todas
          las condiciones de uso que se establecen aquí sin perjudicar la aplicación de la
          correspondiente normativa de obligado cumplimiento legal según el caso.
        </p>
        <p class="body-1">
          Por eso, si las consideraciones detalladas en este aviso legal no son de su conformidad,
          rogamos no haga uso del portal, ya que cualquier uso que haga del mismo o los servicios y
          contenidos en él incluidos implicará la aceptación de los términos legales recogidos en este
          texto.
        </p>
        <p class="body-1">
          La página web de
          <b>GLOSPEN, SL</b> proporciona gran diversidad de información, servicios y
          datos. El usuario asume su responsabilidad en el uso correcto de los sitios web. Esta
          responsabilidad se extenderá a: La veracidad y licitud de las informaciones aportadas por el
          usuario en los formularios emitidos por
          <b>GLOSPEN, SL</b> para acceder a determinados
          contenidos o servicios ofrecidos por la web.
        </p>
        <p class="body-1">
          El uso de la información, servicios y datos ofrecidos por
          <b>GLOSPEN, SL</b> no irán contra las
          disposiciones de estas condiciones, la Ley, la moral, las buenas costumbres o el orden público
          o que, en otro caso, puedan suponer lesión de los derechos de terceros o del funcionamiento
          de los sitios web. A tal efecto, el Usuario se abstendrá de utilizar cualquiera de los contenidos
          con fines o efectos ilícitos, prohibidos en este texto, lesivos de los derechos e intereses de
          terceros, o que de cualquier forma puedan dañar, inutilizar, sobrecargar, deteriorar o impedir la
          normal utilización de los contenidos, otros Usuarios o de cualquier usuario de Internet
          (hardware y software).
        </p>
        <p class="body-1">
          Los usuarios responderán de los daños y perjuicios de toda naturaleza que la empresa
          propietaria de la web pueda sufrir, directa o indirectamente, como consecuencia de
          incumplimiento de cualquiera de las obligaciones derivadas del uso de la Web y de esta política
          de privacidad.
        </p>
        <p class="body-1">
          En particular, ya título meramente indicativo y no exhaustivo, el Usuario se compromete a no
          transmitir, difundir o poner a disposición de terceros informaciones, datos, contenidos,
          mensajes, gráficos, dibujos, archivos de sonido y/o imagen, fotografías de la web.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
  title2: 'POLÍTICA DE PRIVACIDAD',
  content2: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>POLÍTICA DE ENLACES Y EXENCIONES DE RESPONSABILIDAD</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no se hace responsable del contenido de las páginas web a las que pueda
          acceder el usuario a través de los enlaces establecidos en sus sitios web y declara que en
          ningún caso examinará ni ejercitará ningún tipo de control sobre el contenido de otras páginas
          de la red.
        </p>
        <p class="body-1">
          Asimismo, tampoco garantiza la disponibilidad técnica, exactitud, veracidad, validez o legalidad
          de páginas ajenas a su propiedad a las que se pueda acceder a través de los enlaces.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> declara que ha adoptado todas las medidas necesarias para evitar cualquier
          daño que pueda derivarse de la navegación por sus páginas web. En consecuencia,
          <b>GLOSPEN, SL</b> no se hace responsable, en ningún caso, de los eventuales daños que pueda
          sufrir el usuario a causa de la navegación por Internet.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no se responsabiliza de los daños o perjuicios de cualquier tipo producidos en
          el Usuario que traigan causa de fallos o desconexiones en las redes de telecomunicaciones
          que produzcan la suspensión, cancelación, instalación o interrupción del servicio de la web
          durante la prestación del mismo o con carácter previo.
        </p>
        <p class="body-1">
          El acceso a la web:
          <b>www.fbase.tv</b> no implica la obligación por parte de la empresa de controlar
          la ausencia de virus o cualquier otro elemento informático dañino. Corresponde al Usuario, en
          todo caso, la disponibilidad de herramientas adecuadas para la detección y desinfección de
          programas informáticos dañinos.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no se responsabiliza de los daños producidos en los equipos informáticos,
          documentos y/o ficheros de los Usuarios o de terceros durante la prestación del servicio en el
          Portal.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PUBLICIDAD</u>
        </li>

        <p class="body-1">
          La web:
          <b>www.fbase.tv</b> podrá alojar contenidos publicitarios o patrocinados. Los anunciantes o
          patrocinadores son los únicos responsables de asegurarse que el material remitido para su
          inclusión en la web cumple con las leyes que en cada caso puedan ser de aplicación.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> no será responsable de cualquier error, inexactitud o irregularidad que puedan
          contener los contenidos publicitarios o de los patrocinadores.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>MODIFICACIONES</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> se reserva el derecho a realizar las modificaciones que considere oportunas,
          sin aviso previo, en el contenido de sus sitios web, tanto en cuanto a los contenidos de los
          sitios web como por sus condiciones de uso o por las condiciones generales de contratación.
          Dichas modificaciones podrán realizarse, a través de sus sitios web, de cualquier forma
          admisible en derecho y serán de obligado cumplimiento durante el tiempo que estén publicadas
          en la web y hasta que no sean modificadas por otras posteriores.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>RESERVA DE COOKIES</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> se reserva el derecho de utilizar cookies en la navegación del usuario por sus
          sitios web para facilitar la personalización y comodidad de la navegación. Siguiendo la política
          de protección de datos de la empresa,
          <b>GLOSPEN, SL</b> informa que las cookies se asocian al
          usuario anónimo ya su ordenador y no proporcionan por sí mismas ni el nombre ni los apellidos
          del usuario.
        </p>
        <p class="body-1">
          El usuario tiene la posibilidad de configurar su navegador de manera que sea informado de la
          recepción de cookies, pudiendo, si así lo desea, impedir que se instalen en su disco duro. Sin
          embargo, para acceder a los sitios web de
          <b>GLOSPEN, SL</b> no es preceptiva la instalación de
          cookies.
        </p>
        <p class="body-1">
          El usuario se compromete a abstenerse de reproducir, copiar, distribuir, poner a disposición o
          de cualquier otra forma comunicar públicamente, transformar o modificar los Contenidos, a
          menos que se cuente con la autorización del titular de los correspondientes derechos o ello
          resulte legalmente permitido.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PROTECCIÓN DE DATOS PERSONALES</u>
        </li>
        <p class="body-1">
          De conformidad con lo establecido por el Reglamento General-UE-2016/679 del Parlamento y
          Consejo de Europa de Protección de Datos de Carácter Personal, aprobado el 27 de abril de
          2016,
          <b>GLOSPEN, SL</b> informa a los usuarios de sus websites de que estamos obligados a
          guardar secreto profesional sobre los datos personales recabados por la empresa mediante los
          formularios sitos en sus páginas, esta obligación continuara incluso después de haber
          finalizado nuestra relación comercial o contractual, y en ningún caso podremos hacer públicos
          los datos personales de los visitantes y clientes a la web sin su consentimiento.
          <b>
            Los menores
            de 14 años no pueden prestar su consentimiento para que un comercio recoja y trate sus
            datos personales
          </b>; solo sus representantes legales (padres o tutores) son quienes pueden
          hacerlo en su nombre. Aquellos comercios que necesiten tratar datos de menores de 14 años,
          deben disponer de los medios para obtener el consentimiento de sus padres o tutores, por
          ejemplo, mediante un mensaje de correo electrónico dirigido a alguno de ellos que contenga un
          enlace a un formulario electrónico. No se puede pedir a los menores de 14 años datos sobre el
          ámbito familiar, siendo la única excepción los datos de identificación y contacto de los padres o
          tutores.
        </p>
        <p class="body-1">
          Estos datos, serán introducidos en un fichero automatizado bajo la responsabilidad del
          administrador de la web de,
          <b>GLOSPEN, SL</b> con la finalidad de poder facilitar, agilizar y cumplir
          los compromisos establecidos entre ambas partes. Asimismo,
          <b>GLOSPEN, SL</b> informa de la
          posibilidad de ejercer los derechos de
          <b>acceso</b>, que permite al usuario web, conocer que datos
          personales tiene el administrador de esta página y en tal caso contestara en un plazo de 30
          días, siempre que conserve los datos,
          <b>rectificación</b>, que permite corregir errores, modificar los
          datos que sean inexactos o incompletos y garantizar la certeza de la información,
          <b>oposición</b>
          que podrá solicitar y conseguir que no lleve a cabo el tratamiento de datos,
          <b>supresión</b> que
          permite que se supriman los datos inadecuados o excesivos,
          <b>limitación</b>, por el que puede
          solicitar que se limite el tratamiento de sus datos cuando haya ejercido su derecho a la
          rectificación de sus datos personales, y
          <b>portabilidad</b>, para que el usuario pueda obtener una
          copia de los datos personales que haya facilitado en la web a fin de poder transmitirlos a otros
          servicios, estos derechos se podrán ejercer por cualquier medio que deje constancia de su
          envío y de su recepción a la dirección:
          <b>
            CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC-
            II 5º 2ª
          </b>. Código Postal:
          <b>AD700</b>. Localidad:
          <b>
            ESCALDES-ENGORDANY. Provincia: PRINCIPAT
            D&#39;ANDORRA
          </b>. Correo electrónico:
          <b>
            <u>Info@fbase.tv</u>
          </b>, aportando fotocopia del DNI o
          documentación alternativa que acredite su identidad.
        </p>

        <p class="body-1">
          Mientras no nos comunique lo contrario, entenderemos que sus datos no han sido modificados,
          que usted se compromete a notificarnos cualquier variación y que tenemos el consentimiento
          para utilizarlos a fin de poder fidelizar la relación entre las partes.
        </p>
        <p class="body-1">
          El envío de sus datos mediante el/los formularios de nuestra web estará supeditado
          obligatoriamente a que haya leído/aceptado la Política de Privacidad, mediante un check box
          obligatorio al pie del formulario.
        </p>
        <p class="body-1">
          De acuerdo con lo establecido en la Ley 34/2002, de Servicios de la Sociedad de la
          Información y el Comercio Electrónico en su artículo 21, pedimos su consentimiento para poder
          realizar comunicaciones publicitarias que consideremos puedan ser de su interés, por correo
          electrónico o por cualquier otro medio de comunicación electrónica equivalente, este
          consentimiento lo aceptará o negará con un check box obligatorio al pie del formulario.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PROPIEDAD INTELECTUAL</u>
        </li>
        <p class="body-1">
          Los derechos de propiedad intelectual e industrial derivados de todos los textos, imágenes, así
          como de los medios y formas de presentación y montaje de sus páginas pertenecen, por sí
          mismos o como cesionaria, a
          <b>GLOSPEN, SL</b>. Serán, por tanto, obras protegidas con propiedad
          intelectual por el ordenamiento jurídico español y se les podrá aplicar tanto la normativa
          española y comunitaria en este campo, como los tratados internacionales relativos a la materia
          y suscritos por España, Real Decreto Legislativo 1/1996.
        </p>
        <p class="body-1">
          Todos los derechos reservados. En cumplimiento de la Ley de la Propiedad Intelectual se
          prohíbe expresamente la reproducción, distribución, comunicación pública y utilización de la
          totalidad o parte de los contenidos de sus páginas web sin el consentimiento explícito de
          <b>GLOSPEN, SL</b>.
        </p>
        <p class="body-1">
          Así mismo,
          <b>GLOSPEN, SL</b> se reserva la facultad de presentar las acciones civiles o penales
          que considere oportunas por la utilización indebida de sus páginas web y contenidos o por el
          incumplimiento de estas condiciones.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>SELLOS DE CONFIANZA</u>
        </li>
        <p class="body-1">
          Los sellos de confianza son distintivos que se proporcionan a las tiendas online para demostrar
          su calidad y seguridad en la venta online.
        </p>
        <p class="body-1">
          Para conseguir el sello, éstas son auditadas o evaluadas para comprobar que cumplen los
          criterios de seguridad en la compra y cumplimiento legal en materia de privacidad y protección
          de datos de los consumidores.
        </p>
        <p class="body-1">
          Las tiendas que disponen de un sello de confianza están adheridas a un código de conducta y
          suelen ofrecer a los consumidores procedimientos alternativos de resolución de conflictos
          sencillos, rápidos y cómodos.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>CERTIFICADOS DE CUMPLIMIENTO LSSI-CE Y PROTECCIÓN DE DATOS</u>
        </li>
        <p class="body-1">
          <b>www.fbase.tv</b> cumple con la normativa de Protección de Datos vigente y con la
          <b>LSSI-CE</b>, y ha
          sido asesorada en estas normativas por
          <b>
            <a
              target="_blank"
              href="https://www.grupoqualia.net/es/inicio"
            >GRUPO QUALIA</a>
          </b>, por lo que se le otorgan sendos
          certificados en formato de imagen digital para que pueda exponerlos en su sitio web.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>ACCIONES LEGAL, LEGISLACIÓN APLICABLE Y JURISDICCIÓN</u>
        </li>
        <p class="body-1">
          La relación entre el usuario y
          <b>GLOSPEN, SL</b> se regirá por la normativa Europea vigente y
          serán competentes para decidir sobre cualquier controversia que pueda surgir entre el usuario
          y
          <b>GLOSPEN, SL</b>, los juzgados o tribunales de la localidad de
          <b>
            ESCALDES-ENGORDANY,
            PRINCIPAT D’ANDORRA
          </b>.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
}
export default termsAndConditions
